/**
 * 接口域名的管理
 */

const base = {
    //开发环境
    //base: "/okex/web/quant",
    // base:"http://3.112.67.21/okex/quant",

    // base:"http://26.26.26.1:82/quant",  //这里是ok7模拟盘代码的配置，本机电脑，指向flask的url 
    base:"",

};

export default base;



// WEBPACK FOOTER //
// ./src/api/base.js